import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function AboutHero() {
  const { t } = useTranslation();
  return (
    <section className="relative w-full min-h-[420px] md:min-h-[520px] flex items-center justify-center overflow-hidden pt-20">
      <img
        src="https://readdy.ai/api/search-image?query=Stunning%20panoramic%20aerial%20landscape%20view%20of%20Vietnam%20featuring%20dramatic%20limestone%20karst%20mountains%20rising%20from%20emerald%20green%20rice%20terraces%20under%20golden%20morning%20sunlight%20with%20soft%20mist%20floating%20through%20valleys%20serene%20peaceful%20travel%20photography%20cinematic%20wide%20angle%20composition&width=1800&height=900&seq=about-hero-bg&orientation=landscape"
        alt={t('about.heroAlt')}
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center">
        <p className="text-accent-400 text-sm md:text-base tracking-wide uppercase mb-3">
          {t('about.eyebrow')}
        </p>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
          {t('about.heroTitle')}
        </h1>
        <p className="text-white/80 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
          {t('about.heroSubtitle')}
        </p>

        <nav className="mt-8 flex items-center justify-center gap-2 text-sm text-white/70">
          <Link to="/" className="hover:text-white transition-colors">{t('about.home')}</Link>
          <span>/</span>
          <span className="text-white">{t('about.aboutUs')}</span>
        </nav>
      </div>
    </section>
  );
}